/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { concat, pipe, reduce, uniq } from 'ramda';
import { createSelector } from 'reselect';
import {
  groupPlugins,
  selectAllValidationPlugins,
  selectAllViewPlugins,
  selectEnabledViewPlugins
} from '../../common/selectors';
import {
  manageValidationPluginsMode,
  orgValidationUpdates,
  sessionValidationUpdates,
  userValidationUpdates
} from '../data/prefabs';

export const selectModeSettings = createSelector(
  manageValidationPluginsMode.value,
  sessionValidationUpdates.value,
  userValidationUpdates.value,
  orgValidationUpdates.value,
  (mode, sessionSettings, userSettings, orgSettings) => (mode === 'session' ? sessionSettings
    : mode === 'userorg' ? userSettings : orgSettings)
);

export const selectValidationPluginsGrouped = createSelector(
  selectAllValidationPlugins,
  groupPlugins
);

const findUniqueViewValidators = pipe(
  reduce((acc, { validators }) => concat(acc, validators || []), []),
  uniq
);

export const selectAllViewValidators = createSelector(
  selectAllViewPlugins,
  findUniqueViewValidators
);

export const selectEnabledViewValidators = createSelector(
  selectEnabledViewPlugins,
  findUniqueViewValidators
);
